import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Customer } from '../../customer';
import { CustomerProject } from '../../customer-project.interface';
import { Settings } from '../../settings.class';

@Component({
    selector: 'app-customer-project-dialog',
    templateUrl: './customer-project-dialog.component.html',
    standalone: false,
})
export class CustomerProjectDialogComponent {
    static open(dialog: MatDialog, customer: Customer, types: typeof Settings.projectTypes) {
        return dialog.open<CustomerProjectDialogComponent, CustomerProjectDialogComponent['data'], CustomerProject>(
            CustomerProjectDialogComponent,
            {
                panelClass: 'confirm-dialog',
                maxHeight: '98vh',
                width: '500px',
                disableClose: true,
                data: { customer, types },
            }
        );
    }

    constructor(
        public dialogRef: MatDialogRef<CustomerProjectDialogComponent, CustomerProject>,
        @Inject(MAT_DIALOG_DATA) public data: { customer: Customer; types: typeof Settings.projectTypes }
    ) {}
}
